module.exports = __webpack_public_path__ + "img/instagram.abbd677d.png";